import { useMemo, type MutableRefObject } from 'react';

import { useCurrentTheme } from '@dynatrace/strato-components/core';

import { Canvas } from '../../../core/components/canvas/Canvas.js';
import { CanvasContext } from '../../../core/components/canvas/CanvasContext.js';
import { CanvasShape } from '../../../core/components/canvas/types/canvas-shape.js';
import { plotLayout } from '../../../core/components/chart-grid/ChartGrid.sty.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { useHighlightedSeriesIdsState } from '../../hooks/store/selectors.js';
import { useHistogramXScale } from '../../hooks/useHistogramXScale.js';
import { BarChartDisplay } from '../displays/BarChartDisplay.js';
import { DisplayConfigContext } from '../displays/DisplayConfigContext.js';

export const HistogramCanvasLayout = () => {
  const { width, height } = useGridPlotSize();
  const highlightedSeriesIds = useHighlightedSeriesIdsState();
  const theme = useCurrentTheme();
  const { xScale } = useHistogramXScale();

  const displayConfigContext = useMemo(
    () => ({
      highlightedSeriesIds,
    }),
    [highlightedSeriesIds, theme],
  );

  return (
    <DisplayConfigContext.Provider value={displayConfigContext}>
      <div data-testid="histogram-canvas" className={plotLayout}>
        <CanvasContext.Provider
          value={{
            shapeRefs: new Map<string, MutableRefObject<CanvasShape>>(),
          }}
        >
          <Canvas width={width} height={height}>
            <BarChartDisplay xScale={xScale} />
          </Canvas>
        </CanvasContext.Provider>
      </div>
    </DisplayConfigContext.Provider>
  );
};

HistogramCanvasLayout['displayName'] = 'HistogramCanvasLayout';
